import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import {Clear} from '@mui/icons-material'
import {injectIntl} from 'react-intl'
import {setApplicationLogo, setApplicationName} from 'modules/applications/actions'
import {getAppName} from 'utils/utils'

const Logo = styled.div`
    background-color: #3c3d4c;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    height: 107px;
    width: 256px;
    display: flex;
    align-items: center;
    margin: 30px 0;

    img {
        max-width: 216px;
        max-height: 67px;
        margin: 20px;
    }

    svg {
        right: 5px;
        top: 5px;
        position: absolute;
        cursor: pointer;
        color: #fff;
        opacity: 0;
        transition: opacity 250ms cubic-bezier(.55, 0, .1, 1);
    }

    :hover {
        svg {
            opacity: 1;
        }
    }
`

const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
`

const Field = styled(TextField)`
    width: 256px;
`

class MainSettings extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            logo: '',
            name: ''
        }
    }

    componentDidMount() {
        if (this.props.current) {
            this.setState({ logo: this.props.logo })
        }
    }

    componentDidUpdate(props) {
        if (props.logo !== this.props.logo) {
            this.setState({ logo: this.props.logo })
        }
    }

    handleDownload = (e) => {
        const file = e.currentTarget.files[0]

        if (file) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => this.setState({ logo: reader.result })
            reader.onerror = (error) => alert(error)
        }
    }

    handleUpdate = () => {
        if (this.state.name) {
            this.props.setApplicationName(this.state.name)
            this.setState({name: ''})
        }

        if (this.state.logo !== this.props.logo) {
            this.props.setApplicationLogo(this.state.logo)
        }
    }

    handleClear = (e) => {
        e.stopPropagation()
        this.input.value = ''
        this.setState({ logo: '' })
    }

    handleClick = () => {
        this.input.click()
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        const name = getAppName()
        const { intl } = this.props

        return (
            <div>
                <Field
					variant="standard"
                    defaultValue={name}
                    onChange={this.handleChange}
                    label={intl.formatMessage({id: "settings.company_name"})}
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{
                        maxLength: global.NAME_MAX_LENGTH,
                        name: 'name'
                    }}
                />
                <Logo onClick={this.handleClick}>
                    <img src={this.state.logo} alt='' />
                    {this.state.logo &&
                        <Clear onClick={this.handleClear} />
                    }
                </Logo>
                <Input type='file'
                    onChange={this.handleDownload} ref={el => this.input = el}
                    accept="image/jpeg, image/png, image/gif"
                />
                <Button variant="contained"
                    color="primary"
                    onClick={this.handleUpdate}
                    disabled={this.state.logo === this.props.logo &&
                        (this.state.name === name || this.state.name.replace(/\s/g, '') === '')}
                >
                    {intl.formatMessage({id: "app.confirm_save"})}
                </Button>
            </div>
        )
    }
}

const mapStateToProps = ({applications}) => ({
    current: applications.current,
    logo: applications.logo
})

export default connect(mapStateToProps, {
    setApplicationLogo,
    setApplicationName
})(injectIntl(MainSettings))
